"use client";
import { useEffect, useState } from "react";

/**
 * 客户端实现的 useSearchParams hook
 * 用于替代 next/navigation 的 useSearchParams
 * 直接从浏览器的 window.location.search 获取 URL 参数
 */
export function useURLSearchParams() {
  const [searchParams, setSearchParams] = useState<URLSearchParams | null>(
    null,
  );

  useEffect(() => {
    // 只在客户端运行
    if (typeof window !== "undefined") {
      const params = new URLSearchParams(window.location.search);
      setSearchParams(params);
    }
  }, []);

  return searchParams;
}
